import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type EquipmentAvatarProps = React.HTMLAttributes<HTMLSpanElement> & {
  defaultChildren?: ReactNode;
  hideTooltip?: boolean;
  children?: ReactNode;
};

export const EquipmentAvatar = ({
  defaultChildren,
  className = '',
  hideTooltip = false,
  children,
  ...props
}: EquipmentAvatarProps) => {
  const { t } = useTranslation('app');

  if (!hideTooltip) {
    return (
      <AppTooltip context={<span>{t('pages.equipment.removed')}</span>}>
        <span
          className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full font-inter text-white ${
            className || 'h-7 w-7 bg-purple-400'
          }`}
          {...props}></span>
      </AppTooltip>
    );
  }

  return (
    <span
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full font-inter text-white ${
        className || 'h-7 w-7 bg-purple-400'
      }`}
      {...props}>
      {defaultChildren || children}
    </span>
  );
};
